import React from "react";
import clsx from "clsx";

import ContainerBleed from "@app/components/ContainerBleed";

import styles from "./CodeFigure.module.css";

export default function CodeFigure({ side, children, caption, ...rest }) {
  return (
    <ContainerBleed tag="figure" {...rest}>
      <div
        className={clsx(
          side === "left" && styles.sideLeft,
          side === "right" && styles.sideRight,
          styles.content,
        )}
      >
        <div className={styles.margin}>
          {children}
          <figcaption>{caption}</figcaption>
        </div>
      </div>
    </ContainerBleed>
  );
}
